import React from 'react'
import Head from '@fs/zion-head'

export default function StructuredData({ data, dataTestId = 'structured-data' }) {
  if (!data || Object.keys(data).length === 0) return null
  data['@context'] = 'https://schema.org'
  return data ? (
    <Head>
      <script type="application/ld+json" data-testid={dataTestId}>
        {JSON.stringify(data, null, 2)}
      </script>
    </Head>
  ) : null
}
